// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","197":"75fc9c18","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"9193514dab78351496a6","197":"45ca0ce437bc1efd9430","293":"18c84cad35d8a27ab7c5"}[chunkId] + ".js";
};